import * as React from 'react'
import { SkeletonBar } from 'uiComponents/skeleton/skeleton'
import { PRODUCTS } from 'capacity/copy'
import { TakesUpState } from 'capacity/derive/takesUp'

interface TakesUpCapacityCellProps {
    takesUp: TakesUpState
    isBundle: boolean
}

export function TakesUpCapacityCell({ takesUp, isBundle }: TakesUpCapacityCellProps) {
    if (isBundle) {
        return <span>{PRODUCTS.takesUp.bundle}</span>
    }
    if (!takesUp) {
        return <span className="capacity-muted">{PRODUCTS.onSale.none}</span>
    }
    if (takesUp === 'pending') {
        return <SkeletonBar width="8rem" height="0.9rem" />
    }
    if (takesUp === 'unavailable') {
        return <span className="capacity-muted">{PRODUCTS.takesUp.unavailable}</span>
    }
    return <span>{PRODUCTS.takesUp[takesUp.kind]}</span>
}
